import { Loader2 } from "lucide-react";

export const LoadingOverlay = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background">
      <Loader2 className="h-8 w-8 animate-spin text-selise-blue-500" />
    </div>
  );
};
